export default __webpack_public_path__ + "static/media/alerts.c3390417.svg";